import { useMutation } from '@tanstack/react-query';
import { ASSIST_API } from 'services/assist-api/axios';
import type { AssistQuery } from 'services/assist-api/query';
import { AssistQueryClient } from 'services/assist-api/query-client';
import type { BaseNotification } from './check';

type DismissNotificationVariables = { notification: number; user: number };

export const useDismissNotification: AssistQuery.UseMutation<
  BaseNotification,
  DismissNotificationVariables
> = (options) =>
  useMutation(
    ({ notification, user }: DismissNotificationVariables) =>
      ASSIST_API.post('notification-dismisseds', {
        data: {
          type: 'NotificationDismissed',
          relationships: {
            notification: {
              data: { id: `/api/v2/notifications/${notification}`, type: 'Notification' }
            },
            user: { data: { id: `/api/v2/users/${user}`, type: 'User' } }
          }
        }
      }),
    {
      ...options,
      onSettled: (...args) => {
        AssistQueryClient.invalidateQueries(['notifications']);
        if (options?.onSettled) {
          options.onSettled(...args);
        }
      }
    }
  );
